import Form from 'src/utils/Form.js'

class IncomingPaymentMethod extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`payment-methods/incoming/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`payment-methods/incoming?${parameters}`).then(then)
  }

  create(then) {
    return super.post(`payment-methods/incoming`).then(then)
  }

  update(then) {
    return super.patch(`payment-methods/incoming/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`payment-methods/incoming/${this.id}`).then(then)
  }
}

export default IncomingPaymentMethod
